import '../javascript/application'
import "~/controllers"
// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

import "@hotwired/turbo-rails"

const BROWSER_TIME_ZONE_COOKIE = "browser_time_zone"
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

function readCookie(name) {
  const cookieSegment = document.cookie
    .split(";")
    .map((segment) => segment.trim())
    .find((segment) => segment.startsWith(`${name}=`))

  if (!cookieSegment) return null
  return decodeURIComponent(cookieSegment.slice(name.length + 1))
}

function syncBrowserTimeZoneCookie() {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (!browserTimeZone) return

  const previousValue = readCookie(BROWSER_TIME_ZONE_COOKIE)
  if (previousValue === browserTimeZone) return

  document.cookie = `${BROWSER_TIME_ZONE_COOKIE}=${encodeURIComponent(browserTimeZone)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; samesite=lax`

  // Re-render server-side "today" calculations immediately after timezone changes.
  if (readCookie(BROWSER_TIME_ZONE_COOKIE) === browserTimeZone) {
    window.location.reload()
  }
}

document.addEventListener("turbo:load", syncBrowserTimeZoneCookie)
syncBrowserTimeZoneCookie()

// Example: Load Rails libraries in Vite.
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
